import React, { useState, useEffect } from 'react'

import { Card, CardContent, Typography, Tooltip, Stack } from '@mui/material'
import ClearIcon from "@mui/icons-material/Clear"
import IconButton from "@mui/material/IconButton"
import InputLabel from '@mui/material/InputLabel'
import { useTranslation } from "react-i18next"
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import dayjs from 'dayjs'
import update from 'immutability-helper'
import { useLocalStorage } from '@uidotdev/usehooks'
import { t } from 'i18next'

import AppLayout from '../../components/Layouts/AppLayout'
import AddButton from '../../components/AddButton'
import Loading from '../../components/Loading'
import { useStateContext } from '../../context/ContextProvider'
import axios from '../../lib/axios'
import DailyBoardTableSales from '../../components/DailyBoardTableSales'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Create3PLSalesOrderIcon from '../../components/icons/Create3PLSalesOrderIcon'
import CreatePickupIcon from '../../components/icons/CreatePickupIcon'
import { useAuth } from '../../hooks/auth'
import { areAllValid, isValid } from '../../helpers/helper'
import Navigation from '../../components/sales_purchase_orders/Navigation'
import InventoryStatusScrollableRow from '../../components/admin_dashboard/InventoryStatusScrollableRow'
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import { includes, isNull } from 'lodash'
import CreateBrokeredSalesOrderIcon from '../../components/icons/CreateBrokeredSalesOrderIcon'
import CreateSalesOrder from '../../components/sales_purchase_orders/CreateSalesOrder'
import { buildUrl } from '../../helpers/apiHelper'

const SalesOrder = () => {

    const { user } = useAuth({ middleware: 'guest ' })

    const { choosesite, setChoosesite, company_id, config, pusher, features } = useStateContext()
    const [filters, setFilters] = useLocalStorage("filters", null)
    const location = useLocation()
    const navigate = useNavigate()
    const [quotePrefillData, setQuotePrefillData] = useState(null)

    const [pageToday, setPageToday] = useState(1)
    const [rowsPerPageToday, setRowsPerPageToday] = useState(10)
    const [pageFuture, setPageFuture] = useState(1)
    const [rowsPerPageFuture, setRowsPerPageFuture] = useState(10)
    const [ordersTodayTotal, setOrdersTodayTotal] = useState(0)
    const [ordersFutureTotal, setOrdersFutureTotal] = useState(0)

    const [sort, setSort] = useState('created_at,desc');
    const [sortFuture, setSortFuture] = useState('created_at,desc');

    const [open, setOpen] = useState(false)
    const [openSalesPickup, setOpenSalesPickup] = useState(false)
    const [open3PL, setOpen3PL] = useState(false)
    const [openCreateBrokeredSalesOrder, setOpenCreateBrokeredSalesOrder] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [random, setRandom] = useState(null)

    const [salesOrderStatuses, setSalesOrderStatuses] = useState([])
    const [salesOrderStatusesFuture, setSalesOrderStatusesFuture] = useState([])
    const [salesOrderDates, setSalesOrderDates] = useState([])
    const [salesOrderShipmentDates, setSalesOrderShipmentDates] = useState([])
    const [salesOrderDatesFuture, setSalesOrderDatesFuture] = useState([])
    const [salesOrderShipmentDatesFuture, setSalesOrderShipmentDatesFuture] = useState([])

    /* orders */
    const [orders, setOrders] = useState([])
    const [ordersFuture, setOrdersFuture] = useState([])

    /* filters */
    const [type, setType] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_present_type || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })
    const [searchStatus, setSearchStatus] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_present_status || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })
    const [searchDate, setSearchDate] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_present_requested_delivery_date || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })
    const [searchShipmentDate, setSearchShipmentDate] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_present_shipment_date || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })

    const [typeFuture, setTypeFuture] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_future_type || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })
    const [searchStatusFuture, setSearchStatusFuture] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_future_status || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })
    const [searchDateFuture, setSearchDateFuture] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_future_requested_delivery_date || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })
    const [searchShipmentDateFuture, setSearchShipmentDateFuture] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_future_shipment_date || ''
            } catch (e) {
                return ''
            }
        } else {
            return ''
        }
    })

    // Misc.

    const [inventoryItems, setInventoryItems] = useState([])
    const [isLoadingInventoryItems, setIsLoadingInventoryItems] = useState(true)
    const [isUpdatingInventoryItems, setIsUpdatingInventoryItems] = useState(false)
    const [isInventoryOpen, setIsInventoryOpen] = useState(true)
    const [shownItemType, setShownItemType] = useState(() => {
        if (filters) {
            try {
                return filters[0]?.daily_board_sales_orders_shown_inventory_item_type || 'all'
            } catch (e) {
                return 'all'
            }
        } else {
            return 'all'
        }
    })

    useEffect(() => {
        setChoosesite(localStorage.getItem('site'))
    }, [])

    useEffect(() => {
        if (location.state?.createSalesOrderFromQuote) {
            setQuotePrefillData(location.state.createSalesOrderFromQuote)
            setOpen(true)
            navigate(location.pathname, { replace: true, state: {} })
        }
    }, [])

    useEffect(() => {
        // Unsubscribe on unmount
        return (() => {
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-restored-site-${localStorage.getItem('prev_site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-deleted-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-created-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-updated-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-status-changed-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchaseorder-status-changed-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-productionentry-created-site-${localStorage.getItem('site')}`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-productionentry-updated-site-${localStorage.getItem('site')}`)
        })
    }, [])

    useEffect(() => {
        if(isValid(choosesite)) {
            const channelRestore = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-restored-site-${choosesite}`)
            const channeldelete = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-deleted-site-${choosesite}`)
            const channelcreate = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-created-site-${choosesite}`)
            const channelupdate = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-updated-site-${choosesite}`)
            const channelSalesOrderStatusChanged = pusher.subscribe(`${localStorage.getItem('client_id')}-salesorder-status-changed-site-${choosesite}`)
            const channelPurchaseOrderStatusChanged = pusher.subscribe(`${localStorage.getItem('client_id')}-purchaseorder-status-changed-site-${choosesite}`)
            const channelProductionEntryCreated = pusher.subscribe(`${localStorage.getItem('client_id')}-productionentry-created-site-${choosesite}`)
            const channelProductionEntryUpdated = pusher.subscribe(`${localStorage.getItem('client_id')}-productionentry-updated-site-${choosesite}`)

            channelRestore.bind(`${localStorage.getItem('client_id')}-salesorder-restored-event-site-${choosesite}`, data => {
                setRandom(Math.random())
            })

            channeldelete.bind(`${localStorage.getItem('client_id')}-salesorder-deleted-event-site-${choosesite}`, data => {
                //usporediti datume da vidimo u koji order ide
                setRandom(Math.random())
            })

            channelcreate.bind(`${localStorage.getItem('client_id')}-salesorder-created-event-site-${choosesite}`, data => {
                setRandom(Math.random())
            })

            channelupdate.bind(`${localStorage.getItem('client_id')}-salesorder-updated-event-site-${choosesite}`, data => {
                setRandom(Math.random())
            })

            channelSalesOrderStatusChanged.bind(`${localStorage.getItem('client_id')}-salesorder-status-changed`, data => {
                /* If an Order is Shipped or Undone */
                if(
                    Number(data.status_id) == 9
                    || (Number(data.prev_status_id) == 9 && Number(data.status_id) < Number(data.prev_status_id))
                ) {
                    getInventoryItems(choosesite, true)
                }
            })

            channelPurchaseOrderStatusChanged.bind(`${localStorage.getItem('client_id')}-purchaseorder-status-changed`, data => {
                /* If an Order is Completed or Undone */
                if(
                    Number(data.status_id) == 10
                    || (Number(data.prev_status_id) == 10 && Number(data.status_id) < Number(data.prev_status_id))
                ) {
                    getInventoryItems(choosesite, true)
                }
            })

            channelProductionEntryCreated.bind(`${localStorage.getItem('client_id')}-productionentry-created-event`, data => {
                getInventoryItems(choosesite, true)
            })
            channelProductionEntryUpdated.bind(`${localStorage.getItem('client_id')}-productionentry-updated-event`, data => {
                getInventoryItems(choosesite, true)
            })
        }

        return (() => {
            if(isValid(choosesite)) {
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-restored-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-deleted-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-created-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-updated-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-salesorder-status-changed-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchaseorder-status-changed-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-productionentry-created-site-${choosesite}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-productionentry-updated-site-${choosesite}`)
            }
        })
    }, [choosesite])

    useEffect(() => {
        if(isValid(company_id)) {
            const channelInventoryItemCreate = pusher.subscribe(`${localStorage.getItem('client_id')}-inventoryitem-created-company-${company_id}`)
            const channelInventoryItemUpdate = pusher.subscribe(`${localStorage.getItem('client_id')}-inventoryitem-updated-company-${company_id}`)

            channelInventoryItemUpdate.bind(`${localStorage.getItem('client_id')}-inventoryitem-updated-event`, data => {
                getInventoryItems(null, true)
            })

            channelInventoryItemCreate.bind(`${localStorage.getItem('client_id')}-inventoryitem-created-event`, data => {
                getInventoryItems(null, true)
            })
        }

        return (() => {
            if(isValid(company_id)) {
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-inventoryitem-updated-company-${company_id}`)
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-inventoryitem-created-company-${company_id}`)
            }
        })
    }, [company_id])

    useEffect(() => {
        if(isValid(choosesite)) {
            getInventoryItems(choosesite)
        }
    }, [choosesite])

    useEffect(() => {
        if (isValid(choosesite)) {
            getOrders()
        }
    }, [choosesite, searchDate, searchShipmentDate, searchStatus, pageToday, rowsPerPageToday, type, random, sort])

    useEffect(() => {
        if (isValid(choosesite)) {
            getOrdersFuture()
        }
    }, [choosesite, searchDateFuture, searchShipmentDateFuture, searchStatusFuture, pageFuture, rowsPerPageFuture, typeFuture, random, sortFuture])

    const getOrders = async () => {
        setIsLoading(true)

        const url = buildUrl(
            '/api/list-orders',
            {
                where: {
                    'view_type': 'dailyboard',
                    'order_type': 'sales',
                    'site_id': choosesite,
                    'status_id': searchStatus,
                    'requested_delivery_date': searchDate,
                    'shipment_date': searchShipmentDate,
                    'type': type,
                    'pending': !localStorage.getItem('client_id').includes('bramptonpallet') ? true : '',
                    'time': 'pastpresent',
                    'max_status': !localStorage.getItem('client_id').includes('bramptonpallet') ? 9 : 10,
                    'sort': sort,
                    'page': pageToday,
                    'page_size': rowsPerPageToday
                }
            }
        )

        await axios
            .get(url, config)
            .then(res => {
                const _all_statuses = res.data?.all_statuses ?? [];
                const _statuses = res.data?.available_statuses;
                const _orders = res.data?.data;

                _orders.forEach(_order => {
                    if(_order.prev_status_id) {
                        _order.prev_status = _all_statuses.find((_status) => _status.id == _order.prev_status_id);
                    }
                });

                setSalesOrderStatuses(_statuses)
                setSalesOrderDates(res.data?.available_dates)
                setSalesOrderShipmentDates(res.data?.available_shipment_dates)
                setOrdersTodayTotal(res.data?.total)
                setOrders(_orders)
            })
            .catch((err) => console.error(err))
            .finally(() => setIsLoading(false))
    }

    const getOrdersFuture = async () => {
        setIsLoading(true)

        const url = buildUrl(
            '/api/list-orders',
            {
                where: {
                    'view_type': 'dailyboard',
                    'order_type': 'sales',
                    'site_id': choosesite,
                    'status_id': searchStatusFuture,
                    'requested_delivery_date': searchDateFuture,
                    'shipment_date': searchShipmentDateFuture,
                    'type': typeFuture,
                    'pending': !localStorage.getItem('client_id').includes('bramptonpallet') ? true : '',
                    'time': 'future',
                    'max_status': !localStorage.getItem('client_id').includes('bramptonpallet') ? 9 : 10,
                    'sort': sortFuture,
                    'page': pageFuture,
                    'page_size': rowsPerPageFuture
                }
            }
        )

        await axios
            .get(url, config)
            .then(res => {
                const _all_statuses = res.data?.all_statuses ?? [];
                const _statuses = res.data?.available_statuses;
                const _orders = res.data?.data;

                _orders.forEach(_order => {
                    if(_order.prev_status_id) {
                        _order.prev_status = _all_statuses.find((_status) => _status.id == _order.prev_status_id);
                    }
                    console.log("Prev Status: ", _order.prev_status);
                });

                setSalesOrderStatusesFuture(_statuses)
                setSalesOrderDatesFuture(res.data?.available_dates)
                setSalesOrderShipmentDatesFuture(res.data?.available_shipment_dates)
                setOrdersFutureTotal(res.data?.total)
                setOrdersFuture(_orders)
            })
            .catch((err) => console.error(err))
            .finally(() => setIsLoading(false))
    }

    const getInventoryItems = async (siteId = null, dueToPusherEvent = false) => {
        if(dueToPusherEvent) {
            setIsUpdatingInventoryItems(true)
        } else {
            setIsLoadingInventoryItems(true)
        }

        await axios.get(`/api/inventory-status?site=${isNull(siteId) ? localStorage.getItem('site') : siteId}`, config)
            .then(res => {
                const data = res.data
                setInventoryItems(data)
            })
            .catch(({response}) => {
                console.log(response)
            })
            .finally(() => {
                if(dueToPusherEvent) {
                    setIsUpdatingInventoryItems(false)
                } else {
                    setIsLoadingInventoryItems(false)
                }
            })
    }

    const handleOpen = () => {
        if (open) {
            setQuotePrefillData(null)
        }
        setOpen(!open)
    }

    const handleOpenSalesPickup = () => {
        setOpenSalesPickup(!openSalesPickup)
    }

    const handleOpen3PL = () => {
        setOpen3PL(!open3PL)
    }

    const handleOpenCreateBrokeredSalesOrder = () => {
        setOpenCreateBrokeredSalesOrder(!openCreateBrokeredSalesOrder)
    }

    const handleClearStatus = () => {
        setSearchStatusFuture('')
    }

    const handleClearStatus1 = () => {
        setSearchStatus('')
    }

    const handleClearDate = () => {
        setSearchDateFuture('')
    }

    const handleClearShipmentDate = () => {
        setSearchShipmentDate('')
    }

    const handleClearShipmentDateFuture = () => {
        setSearchShipmentDateFuture('')
    }

    const handleClearDate1 = () => {
        setSearchDate('')
    }

    const handleClearType = () => {
        setType('')
    }

    const handleClearTypeFuture = () => {
        setTypeFuture('')
    }

    const createFilterArray = ({
        present,
        future,
        shownInventoryItemType
    }) => {
        let _filters = JSON.parse(localStorage.getItem('filters')) ?? [{}]

        _filters[0].daily_board_sales_orders_present_type = present?.type
        _filters[0].daily_board_sales_orders_present_status = present?.status
        _filters[0].daily_board_sales_orders_present_requested_delivery_date = present?.requested_delivery_date
        _filters[0].daily_board_sales_orders_present_shipment_date = present?.shipment_date

        _filters[0].daily_board_sales_orders_future_type = future?.type
        _filters[0].daily_board_sales_orders_future_status = future?.status
        _filters[0].daily_board_sales_orders_future_requested_delivery_date = future?.requested_delivery_date
        _filters[0].daily_board_sales_orders_future_shipment_date = future?.shipment_date

        _filters[0].daily_board_sales_orders_shown_inventory_item_type = shownInventoryItemType

        localStorage.setItem('filters', JSON.stringify(_filters))
    }

    useEffect(() => {
        createFilterArray({
            present: {
                type: type,
                status: searchStatus,
                requested_delivery_date: searchDate,
                shipment_date: searchShipmentDate
            },
            future: {
                type: typeFuture,
                status: searchStatusFuture,
                requested_delivery_date: searchDateFuture,
                shipment_date: searchShipmentDateFuture
            },
            shownInventoryItemType: shownItemType
        })
    }, [searchStatus, searchDate, searchShipmentDate, searchStatusFuture, searchDateFuture, searchShipmentDateFuture, type, typeFuture, shownItemType])

    return (
        <>

            {isLoading ? <Loading /> : ''}
            <AppLayout>
                <Card className='w-auto m-6 mt-0'>
                    <CardContent sx={{paddingBottom: (inventoryItems.length <= 0 || !isInventoryOpen) ? '16px !important' : '24px !important'}}>
                        <Stack direction='row' alignItems='center' justifyContent='space-between' marginBottom={((isLoadingInventoryItems || inventoryItems.length > 0) && isInventoryOpen) ? '16px' : '0px'}>
                            <Stack spacing={1} direction='row' alignItems='center'>
                                <GridViewOutlinedIcon fontSize='16px' sx={{color: '#797979'}} />
                                <Typography fontWeight='600' fontSize='16px' lineHeight='24px' letterSpacing='0.3px' component="div">
                                    {t('inventory')}
                                </Typography>

                                {!isLoadingInventoryItems && inventoryItems.length <= 0 ? (
                                    <Typography fontWeight='300' fontSize='16px' lineHeight='24px' letterSpacing='0.3px' component="div">
                                        <em>{t('no_inventory_items_defined')}</em>
                                    </Typography>
                                ) : null}

                                {((!isLoadingInventoryItems && inventoryItems.length <= 0) && includes(['master_admin', 'office_manager'], user?.role)) ? (
                                    <Tooltip disableInteractive title={t('add_new_inventory_item')} placement='right' arrow>
                                        <Link to={'/items'}>
                                            <IconButton disabled={isLoading || isUpdatingInventoryItems} size='small' aria-label='redirect to items view'>
                                                <i className={`fa-solid fa-plus`}></i>
                                            </IconButton>
                                        </Link>
                                    </Tooltip>
                                ) : null}
                            </Stack>
                            {inventoryItems.length > 0 ? (
                                <IconButton onClick={() => setIsInventoryOpen(!isInventoryOpen)} size='small' aria-label='collapse inventory items'>
                                    <i className={`transition duration-150 ease-in-out fa-solid fa-angle-up ${isInventoryOpen ? 'rotate-180' : 'rotate-0'}`}></i>
                                </IconButton>
                            ) : (
                                ''
                            )}
                        </Stack>

                        {isInventoryOpen ? (
                            <div
                                className={`${!isLoadingInventoryItems && inventoryItems.length <= 0 ? 'hidden' : 'flex'} w-full items-center justify-center px-1 rounded-md bg-[#ededf1] mb-[7px]`}
                                style={{ boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.05) inset, 0px 0px 4px 0px rgba(0, 0, 0, 0.05) inset, 0px 0px 2px 0px rgba(0, 0, 0, 0.05) inset' }}
                            >
                                <button onClick={() => setShownItemType('pallet')}  className='w-full'>
                                    <div
                                        className={`w-full text-center m-1 ml-0 ${shownItemType == 'pallet' ? 'bg-white rounded-sm' : 'border-r-2'}`}
                                        style={{
                                            border: shownItemType == 'pallet' ? '0.5px solid rgba(218, 218, 218, 0.02)' : '',
                                            boxShadow: shownItemType == 'pallet' ? '0px 1px 0.75px 0px rgba(0, 0, 0, 0.05), 0px 0.25px 0.25px 0px rgba(0, 0, 0, 0.10)' : ''
                                        }}
                                    >
                                        <p className='p-1.5'>{t('pallets')}</p>
                                    </div>
                                </button>

                                <button onClick={() => setShownItemType('lumber')} className='w-full'>
                                    <div
                                        className={`w-full text-center m-1 ml-0 mr-0 ${shownItemType == 'lumber' ? 'bg-white rounded-sm' : ''}`}
                                        style={{
                                            border: shownItemType == 'lumber' ? '0.5px solid rgba(218, 218, 218, 0.02)' : '',
                                            boxShadow: shownItemType == 'lumber' ? '0px 1px 0.75px 0px rgba(0, 0, 0, 0.05), 0px 0.25px 0.25px 0px rgba(0, 0, 0, 0.10)' : ''
                                        }}
                                    >
                                        <p className='p-1.5'>{t('lumber')}</p>
                                    </div>
                                </button>

                                <button onClick={() => setShownItemType('component')} className='w-full'>
                                    <div
                                        className={`w-full text-center m-1 ml-0 mr-0 ${shownItemType == 'component' ? 'bg-white rounded-sm' : ''}`}
                                        style={{
                                            border: shownItemType == 'component' ? '0.5px solid rgba(218, 218, 218, 0.02)' : '',
                                            boxShadow: shownItemType == 'component' ? '0px 1px 0.75px 0px rgba(0, 0, 0, 0.05), 0px 0.25px 0.25px 0px rgba(0, 0, 0, 0.10)' : ''
                                        }}
                                    >
                                        <p className='p-1.5'>{t('components')}</p>
                                    </div>
                                </button>

                                <button onClick={() => setShownItemType('all')} className='w-full'>
                                    <div
                                        className={`w-full text-center m-1 ml-0 mr-0 ${shownItemType == 'all' ? 'bg-white rounded-sm' : ''}`}
                                        style={{
                                            border: shownItemType == 'all' ? '0.5px solid rgba(218, 218, 218, 0.02)' : '',
                                            boxShadow: shownItemType == 'all' ? '0px 1px 0.75px 0px rgba(0, 0, 0, 0.05), 0px 0.25px 0.25px 0px rgba(0, 0, 0, 0.10)' : ''
                                        }}
                                    >
                                        <p className='p-1.5'>{t('all_inventory')}</p>
                                    </div>
                                </button>
                            </div>
                        ) : null}

                        {inventoryItems.length > 0 ? (
                            <InventoryStatusScrollableRow
                                data={inventoryItems.filter((item) => {
                                    if(shownItemType === 'all') {
                                        return item
                                    } else {
                                        return item.item?.item_type_key == shownItemType
                                    }
                                })}
                                isLoading={isLoadingInventoryItems}
                                isUpdating={!isLoadingInventoryItems && isUpdatingInventoryItems}
                                isOpen={isInventoryOpen}
                                overflow={true}
                            />
                        ) : null}
                    </CardContent>
                </Card>

                <Navigation route='sales-order' user={user} />

                <div className='p-6 flex w-full items-start justify-between gap-5 max-[1830px]:flex-col'>
                    <div className='w-full bg-white rounded-md'>
                        <div className='p-5 flex justify-between items-center border-b border-[#EEEFF2]'>
                            <div className='flex gap-2 items-center'>
                                <span style={{ transform: 'rotate(45deg)', fontSize: '16px', color: '#336195' }} className="flex items-center justify-center">
                                    <i className="fa-solid fa-arrow-up-long"></i>
                                </span>
                                <p style={{ fontWeight: 600, fontSize: '16px' }}>{t('todays_sales_orders')}</p>
                            </div>
                            <div className='flex gap-5 items-center'>
                                {['master_admin', 'office_manager'].includes(user?.role) ? (
                                    <>
                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_so')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpen}><i className="fa-solid fa-plus text-[#333333]"></i></AddButton>
                                            </div>
                                        </Tooltip>

                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_sales_pickup')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpenSalesPickup}>
                                                    <CreatePickupIcon type='cpick' />
                                                </AddButton>
                                            </div>
                                        </Tooltip>

                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_3pl')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpen3PL}>
                                                    <Create3PLSalesOrderIcon />
                                                </AddButton>
                                            </div>
                                        </Tooltip>

                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_brokered_order')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpenCreateBrokeredSalesOrder}>
                                                    <CreateBrokeredSalesOrderIcon />
                                                </AddButton>
                                            </div>
                                        </Tooltip>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div className='p-5 border-b border-[#EEEFF2]'>
                            <div className='flex-row flex justify-between items-end w-full gap-3'>
                                <div className='w-full'>
                                    <FormControl sx={{ width: 'inherit' }}>
                                        <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_status')}</InputLabel>
                                        <Select value={searchStatus} onChange={e => setSearchStatus(e.target.value)}
                                            sx={{
                                                boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                ".MuiSelect-iconOutlined": { display: searchStatus ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                            }}
                                            endAdornment={searchStatus ? (<IconButton sx={{ visibility: searchStatus ? "visible" : "hidden", padding: '0' }} onClick={handleClearStatus1}><ClearIcon /></IconButton>) : false}
                                        >
                                            {
                                                salesOrderStatuses.length < 1 ?
                                                    <MenuItem value='nooptions' disabled sx={{ textDecoration: 'italic' }}>{t('no_options')}</MenuItem>
                                                    :
                                                    salesOrderStatuses.map((status) => (
                                                        <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                                    ))}
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className='w-full'>
                                    {features?.SALES_DAILY_BOARD_SHOW_DATE == 'shipment_date' ? (
                                        <FormControl sx={{ width: 'inherit' }}>
                                            <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_shipment_date')}</InputLabel>
                                            <Select
                                                value={searchShipmentDate}
                                                onChange={e => setSearchShipmentDate(e.target.value)}
                                                sx={{
                                                    boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                    ".MuiSelect-iconOutlined": { display: searchShipmentDate ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                                }}
                                                endAdornment={searchShipmentDate ? (<IconButton sx={{ visibility: searchShipmentDate ? "visible" : "hidden", padding: '0' }} onClick={handleClearShipmentDate}><ClearIcon /></IconButton>) : false}
                                            >
                                                {
                                                    salesOrderShipmentDates.length < 1 ?
                                                        <MenuItem value='nooptions' disabled sx={{ textDecoration: 'italic' }}>{t('no_options')}</MenuItem>
                                                        :
                                                        salesOrderShipmentDates.map((date) => (
                                                            <MenuItem key={`shipment_date-present-${date}`} value={date}>{date}</MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    ) : (
                                        <FormControl sx={{ width: 'inherit' }}>
                                            <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_request_delivery_date')}</InputLabel>
                                            <Select value={searchDate} onChange={e => setSearchDate(e.target.value)}
                                                sx={{
                                                    boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                    ".MuiSelect-iconOutlined": { display: searchDate ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                                }}
                                                endAdornment={searchDate ? (<IconButton sx={{ visibility: searchDate ? "visible" : "hidden", padding: '0' }} onClick={handleClearDate1}><ClearIcon /></IconButton>) : false}
                                            >
                                                {
                                                    salesOrderDates.length < 1 ?
                                                        <MenuItem value='nooptions' disabled sx={{ textDecoration: 'italic' }}>{t('no_options')}</MenuItem>
                                                        :
                                                        salesOrderDates.map((date) => (
                                                            <MenuItem key={date} value={date}>{date}</MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                </div>

                                <div className='w-full'>
                                    <FormControl sx={{ width: 'inherit' }}>
                                        <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_type')}</InputLabel>
                                        <Select
                                            value={type}
                                            onChange={e => setType(e.target.value)}
                                            sx={{
                                                boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                ".MuiSelect-iconOutlined": { display: type ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                            }}
                                            endAdornment={type ? (<IconButton sx={{ visibility: type ? "visible" : "hidden", padding: '0' }} onClick={handleClearType}><ClearIcon /></IconButton>) : false}
                                        >
                                            <MenuItem value={'SHIPMENT'}>{t('standard')}</MenuItem>
                                            <MenuItem className='pickup' value={'CUSTOMER PICKUP'}>{t('customer_pickup')}</MenuItem>
                                            {!['dispatcher'].includes(user?.role) ? (
                                                <MenuItem className='tpl' value={'3PL'}>{t('3PL')}</MenuItem>
                                            ) : (
                                                null
                                            )}
                                            <MenuItem className="brokered" value={'BROKERED'}>{t('brokered')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                        <div>
                            <DailyBoardTableSales
                                items={orders}
                                user={user}
                                total={ordersTodayTotal}
                                page={pageToday}
                                rowsPerPage={rowsPerPageToday}
                                opc={setPageToday}
                                orppc={setRowsPerPageToday}
                                setIsLoading={setIsLoading}
                                osc={setSort}
                                showDate={features?.SALES_DAILY_BOARD_SHOW_DATE}
                            />
                        </div>
                    </div>
                    <div className='w-full bg-white rounded-md'>
                        <div className='p-5 flex justify-between items-center border-b border-[#EEEFF2]'>
                            <div className='flex gap-2 items-center'>
                                <span style={{ transform: 'rotate(45deg)', fontSize: '16px', color: '#336195' }} className="flex items-center justify-center">
                                    <i className="fa-solid fa-arrow-up-long"></i>
                                </span>
                                <p style={{ fontWeight: 600, fontSize: '16px' }}>{t('future_sales_orders')}</p>
                            </div>
                            <div className='flex gap-5 items-center'>
                                {['master_admin', 'office_manager'].includes(user?.role) ? (
                                    <>
                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_so')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpen}><i className="fa-solid fa-plus text-[#333333]"></i></AddButton>
                                            </div>
                                        </Tooltip>

                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_sales_pickup')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpenSalesPickup}>
                                                    <CreatePickupIcon type='cpick' />
                                                </AddButton>
                                            </div>
                                        </Tooltip>

                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_3pl')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpen3PL}>
                                                    <Create3PLSalesOrderIcon />
                                                </AddButton>
                                            </div>
                                        </Tooltip>

                                        <Tooltip disableInteractive title={user?.cannot_create ? t('free_limit_exceeded') : t('create_new_brokered_order')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={user?.cannot_create ?? true} onClick={handleOpenCreateBrokeredSalesOrder}>
                                                    <CreateBrokeredSalesOrderIcon />
                                                </AddButton>
                                            </div>
                                        </Tooltip>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div className='p-5 border-b border-[#EEEFF2]'>
                            <div className='flex-row flex justify-between items-end w-full gap-3'>
                                <div className='w-full'>
                                    <FormControl sx={{ width: 'inherit' }}>
                                        <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_status')}</InputLabel>
                                        <Select
                                            value={searchStatusFuture}
                                            onChange={e => setSearchStatusFuture(e.target.value)}
                                            label="Search role"
                                            sx={{
                                                boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                ".MuiSelect-iconOutlined": { display: searchStatusFuture ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                            }}
                                            endAdornment={searchStatusFuture ? (<IconButton sx={{ visibility: searchStatusFuture ? "visible" : "hidden", padding: '0' }} onClick={handleClearStatus}><ClearIcon /></IconButton>) : false}
                                        >
                                            {
                                                salesOrderStatusesFuture.length < 1 ?
                                                    <MenuItem value='nooptions' disabled sx={{ textDecoration: 'italic' }}>{t('no_options')}</MenuItem>
                                                    :
                                                    salesOrderStatusesFuture.map((status) => (
                                                        <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                                    ))}
                                        </Select>

                                    </FormControl>
                                </div>

                                <div className='w-full'>
                                    {features?.SALES_DAILY_BOARD_SHOW_DATE == 'shipment_date' ? (
                                        <FormControl sx={{ width: 'inherit' }}>
                                            <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_shipment_date')}</InputLabel>
                                            <Select
                                                value={searchShipmentDateFuture}
                                                onChange={e => setSearchShipmentDateFuture(e.target.value)}
                                                sx={{
                                                    boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                    ".MuiSelect-iconOutlined": { display: searchShipmentDateFuture ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                                }}
                                                endAdornment={searchShipmentDateFuture ? (<IconButton sx={{ visibility: searchShipmentDateFuture ? "visible" : "hidden", padding: '0' }} onClick={handleClearShipmentDateFuture}><ClearIcon /></IconButton>) : false}
                                            >
                                                {
                                                    salesOrderShipmentDatesFuture.length < 1 ?
                                                        <MenuItem value='nooptions' disabled sx={{ textDecoration: 'italic' }}>{t('no_options')}</MenuItem>
                                                        :
                                                        salesOrderShipmentDatesFuture.map((date) => (
                                                            <MenuItem key={`shipment_date-future-${date}`} value={date}>{date}</MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    ) : (
                                        <FormControl sx={{ width: 'inherit' }}>
                                            <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_request_delivery_date')}</InputLabel>
                                            <Select
                                                value={searchDateFuture}
                                                onChange={e => setSearchDateFuture(e.target.value)}
                                                label="Search Past Or Present Date"
                                                sx={{
                                                    boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                    ".MuiSelect-iconOutlined": { display: searchDateFuture ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                                }}
                                                endAdornment={searchDateFuture ? (<IconButton sx={{ visibility: searchDateFuture ? "visible" : "hidden", padding: '0' }} onClick={handleClearDate}><ClearIcon /></IconButton>) : false}
                                            >
                                                {
                                                    salesOrderDatesFuture.length < 1 ?
                                                        <MenuItem value='nooptions' disabled sx={{ textDecoration: 'italic' }}>{t('no_options')}</MenuItem>
                                                        :
                                                        salesOrderDatesFuture.map((date) => (
                                                            <MenuItem key={date} value={date}>{date}</MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                </div>

                                <div className='w-full'>
                                    <FormControl sx={{ width: 'inherit' }}>
                                        <InputLabel sx={{ fontSize: '12px', lineHeight: 2 }} id="demo-simple-select-standard-label">{t('search_by_type')}</InputLabel>
                                        <Select
                                            value={typeFuture}
                                            onChange={e => setTypeFuture(e.target.value)}
                                            sx={{
                                                boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 'none !important' }, background: '#F5F5F5', borderRadius: '6px',
                                                ".MuiSelect-iconOutlined": { display: typeFuture ? 'none !important' : '' }, "&.Mui-focused .MuiIconButton-root": { color: 'rgba(0,0,0,.42)' }
                                            }}
                                            endAdornment={typeFuture ? (<IconButton sx={{ visibility: typeFuture ? "visible" : "hidden", padding: '0' }} onClick={handleClearTypeFuture}><ClearIcon /></IconButton>) : false}
                                        >
                                            <MenuItem value={'SHIPMENT'}>{t('standard')}</MenuItem>
                                            <MenuItem className='pickup' value={'CUSTOMER PICKUP'}>{t('customer_pickup')}</MenuItem>
                                            {!['dispatcher'].includes(user?.role) ? (
                                                <MenuItem className='tpl' value={'3PL'}>{t('3PL')}</MenuItem>
                                            ) : (
                                                null
                                            )}
                                            <MenuItem className="brokered" value={'BROKERED'}>{t('brokered')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                        <div>
                            <DailyBoardTableSales
                                items={ordersFuture}
                                user={user}
                                total={ordersFutureTotal}
                                page={pageFuture}
                                rowsPerPage={rowsPerPageFuture}
                                opc={setPageFuture}
                                orppc={setRowsPerPageFuture}
                                setIsLoading={setIsLoading}
                                osc={setSortFuture}
                                showDate={features?.SALES_DAILY_BOARD_SHOW_DATE}
                            />
                        </div>
                    </div>
                </div>

                <CreateSalesOrder open={open} handleOpen={handleOpen} setIsLoading={setIsLoading} type='SHIPMENT' prefillData={quotePrefillData}/>
                <CreateSalesOrder open={openSalesPickup} handleOpen={handleOpenSalesPickup} setIsLoading={setIsLoading} type='CUSTOMER PICKUP'/>
                <CreateSalesOrder open={open3PL} handleOpen={handleOpen3PL} setIsLoading={setIsLoading} type='3PL'/>
                <CreateSalesOrder open={openCreateBrokeredSalesOrder} handleOpen={handleOpenCreateBrokeredSalesOrder} setIsLoading={setIsLoading} type='BROKERED'/>
            </AppLayout>

        </>
    )
}

export default SalesOrder

